<template>
    <div>
        <base-header type="gray-100" class="pb-6 pb-8 pt-5 pt-md-5">
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                    <div class="card shadow">
                      <div class="card-header border-0">
                        <div class="row align-items-center">
                          <div class="col head">
                            <h3 class="mb-0">
                              Usuários
                            </h3>

                            <base-button size="sm" class="clickable" @click="goCsv()">Exportar</base-button>
                          </div>
                        </div>
                      </div>
                      <div class="d-flex column px-3 mb-4">
                        <base-button class="align-self-start" :disabled="aplicandoFiltros" :icon="aplicandoFiltros ? 'fas fa-circle-notch fa-spin' : filtrosAlterados ? 'fas fa-check' : 'fas fa-filter'" size="sm" :type="filtrosAlterados ? 'info' : 'default'" :outline="!filtroAberto && !aplicandoFiltros" @click="aplicarFiltros()">{{filtrosAlterados ? 'Aplicar filtros' : 'Filtros'}}</base-button>
                        <div class="row filtros px-2 mt-3" v-show="filtroAberto">

                          <base-input class="mr-2 flex-grow-1" type="text" placeholder="nome" v-model="filtros.nome"></base-input>

                          <base-input class="mr-2 flex-grow-1">
                            <multiselect
                              v-model="filtros.status"
                              track-by="valor"
                              label="nome"
                              :options="status"
                              placeholder="por status"
                              :multiple="true"
                              selectLabel="Selecionar"
                              selectedLabel="✔"
                              deselectLabel="Limpar"
                            >
                              <span slot="noResult">Todos os status</span>
                            </multiselect>
                          </base-input>
                        </div>
                        <base-button size="sm" v-if="filtroAberto" class="limpar mt-2 align-self-end clickable small" outline @click="limparFiltros()">Limpar filtros</base-button>
                      </div>

                      <div class="table-responsive">
                        <template>
                          <base-table class="table align-items-center table-flush"
                                      tbody-classes="list"
                                      :data="usuariosList">
                            <template slot="columns">
                              <th>ID</th>
                              <th class="text-center">Tipo</th>
                              <th>Nome Completo / Razão Social</th>
                               <th>E-mail</th>
                              <th>Data de Cadastro</th>
                              <th>Data de Atualização</th>
                              <th class="text-center">Status</th>
                              <th></th>
                            </template>

                            <template slot-scope="{row}">
                              <th scope="row">
                                <span>{{ row.prefix }}{{ row.idx }}</span>
                              </th>
                              <th scope="row"  class="text-center">
                                <badge class="mr-4" :type="setTipo(row.tipo, 'color')">
                                  {{setTipo(row.tipo, 'label')}}
                                </badge>
                              </th>
                              <td>
                                {{ row.nome }}
                              </td>
                                <td>
                                {{ row.email }}
                              </td>
                              <td>
                                <span class="name mb-0 text-sm"> {{formatarData(row.created_at)}}</span>
                              </td>
                              <td>
                                <span class="name mb-0 text-sm"> {{formatarData(row.updated_at)}}</span>
                              </td>
                              <td class="text-center">
                                <badge class="mr-4" :type="setStatus(row.ativo, 'color')">
                                  {{setStatus(row.ativo, 'label')}}
                                </badge>
                              </td>
                              <td class="text-right">
                                  <base-button :to="'/usuarios/'+row.tipo+'/'+row.id" type="default" icon="far fa-eye" size="sm" title="Visualizar usuário"></base-button>
                              </td>

                            </template>

                          </base-table>
                        </template>
                      </div>

                       <template v-if="loading">
                          <div class="m-2">
                            <skeleton altura="60px" :velocidade="2.2" :atraso="0.2" :itens="1" classItem="mb-2"></skeleton>
                          </div>
                        </template>

                       <div class="card-footer d-flex justify-content-center" v-if="!loading">
                        <span class="text-size-xl cursor" @click="loadMore()">
                          <i class="fas fa-chevron-circle-down"></i>
                        </span>
                      </div>

                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
  import usuarios from '@/cflow/usuarios.js'
  //import parametros from "@/cflow/parametros.js";
  import BaseButton from '../../components/BaseButton.vue';
  import BaseInput from '../../components/BaseInput.vue';
  import Multiselect from "vue-multiselect";
  import storage from 'storage';
  import config from 'config';
  export default {
    name: 'tables',
    components: {
      Multiselect,
      BaseButton,
      BaseInput
    },
    methods: {
      goCsv: function() {

          const api = config[process.env.NODE_ENV].api.endpoint;
          const csv = `${api}/csv/usuarios`;
          window.location = csv;

      },
        setTipo: function(tipo, flag) {
        let tiposList;
        if(flag == 'color') tiposList = { 'lab' : 'default', 'den' : 'info'};
        if(flag == 'label') tiposList = { 'lab' : 'Laboratório', 'den' : 'Dentista'};
       for (let key in tiposList) {
            if(tipo == key) {
                return tiposList[key];
            }
        }
      },
      setStatus: function(status, flag) {
        let statusList;
        if(flag == 'color') statusList = { '0' : 'warning', '1' : 'success'};
        if(flag == 'label') statusList = { '0' : 'Inativo', '1' : 'Ativo'};
       for (let key in statusList) {
            if(status == key) {
                return statusList[key];
            }
        }
      },
      aplicarFiltros() {
        this.filtroAberto = !this.filtroAberto
        if(this.filtrosAlterados){
          // se os filtros mudaram, então aplicar eles.
          this.aplicandoFiltros = true;
          this.loading = true;
          usuarios.listar({filtros: this.filtros}, 0, 0).then(res => {
            this.usuariosList = res;
            this.aplicandoFiltros = false;
            this.filtrosAlterados = false;
            this.loading = false;
          }).catch(erro => {
            console.err('Ocorreu um erro', erro)
            this.aplicandoFiltros = false;
          })
        }
      },
      limparFiltros() {
        this.filtros = {
          numero: null,
          data: null,
          status: null,
          dentista: null,
          paciente: null
        }
      },
      loadMore: function() {
        //this.skiped += JSON.stringify(this.idxList);
        this.initLoad(this.skipedLab, this.skipedDen);
      },
      initLoad: function(skipedLab, skipedDen) {
        this.loading = true;
        var user = storage.get("user");
        //var labId = 0;
        if(user.tipo && user.tipo == 'lab') {
          //labId = user.id;
        }
        Promise.all([usuarios.listar([],skipedLab, skipedDen)]).then( res => {
          this.usuariosList = this.usuariosList.concat(res[0]);
          this.loading = false;

          res[0].forEach(item => {
            if(item.tipo == 'den') this.skipedDen++;
            if(item.tipo == 'lab') this.skipedLab++;
          })
        })
      }
    },
    watch: {
      filtros: {
        deep: true,
        handler(){
          this.filtrosAlterados = true
        }
      }
    },
    data() {
      return {
        loading: false,
        skipedLab: 0,
        skipedDen: 0,
        usuariosList:[],
        idxList:[],
        status: [{'nome': 'Laboratórios', 'valor': 'lab'}, {'nome': 'Dentistas', 'valor': 'den'}],
        coresStatus: ['warning','info','primary','info','info','success','danger','danger'],
        filtrosAlterados: false,
        filtroAberto: false,
        aplicandoFiltros: false,
        filtros: {
            status: null,
            none: null
        },
        opcoesFiltros: {
          dentista: [],
          paciente: [],
        }
      }
    },
    mounted(){
      this.initLoad(0, 0);
    }
  };
</script>
<style lang="scss" scoped>
.filtros .form-group{
  width: 150px;
}
.head {
  display: flex;
  justify-content: space-between;
}
</style>
